import React, { useState, useEffect } from 'react'
import { Table, Button, Modal, Row, Col, Tooltip, Popconfirm, Spin } from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import Layouts from '../../components/Layouts'
import { toast } from 'react-toastify'
import AddEditEvent from './AddEditEvent'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'

const EmailEventList = () => {
  const [eventList, setEventList] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [loading, setLoading] = useState(false)
  const loginUserId = localStorage.getItem('loggedInUserID');

  useEffect(() => {
    fetchEventList()
  }, [])

  const fetchEventList = async () => {
    setLoading(true);
    try {
      const insurerId = parseInt(localStorage.getItem('loggedInUserID'), 10);

      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/api/EmailEvent/GetByInsurer/${insurerId}`,
        'GET'
      );

      if (response && Array.isArray(response)) {
        setEventList(response);
      } else if (response?.data && Array.isArray(response.data)) {
        setEventList(response.data);
      } else {
        toast.error('No events found for this insurer');
      }
    } catch (error) {
      console.error('Error fetching events:', error);
      toast.error('Error fetching events');
    } finally {
      setLoading(false);
    }
  };



  const handleAdd = () => {
    setSelectedEvent(null)
    setModalVisible(true)
  }

  const handleEdit = (id) => {
    setSelectedEvent(id); 
    setModalVisible(true);
  };

  const handleDelete = async id => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/api/EmailEvent/Delete/${id}`,
        'POST',
      )
      if (res.success) {
        toast.success('Event deleted successfully')
        fetchEventList()
      } else {
        toast.error(res.message || 'Failed to delete event')
      }
    } catch (err) {
      toast.error('Error deleting event')
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchEventList()
  }

  const columns = [
    {
      title: 'Module Name',
      dataIndex: 'moduleName',
      key: 'moduleName',
    },
    {
      title: 'Template Name',
      dataIndex: 'templateName',
      key: 'templateName',
    },
    {
      title: 'period',
      dataIndex: 'period',
      key: 'period',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Tooltip title="Edit Assignment">
            <Button type="primary" onClick={() => handleEdit(record.id)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure you want to delete this email event?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <Button type="danger" className="delete_btn" style={{ marginLeft: 8 }}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]

  return (
    <div title="Event List" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3
                style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                Event Management
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}></Col>
          <Col xs={24} sm={24} md={6} lg={4}>
            <Button type="primary" onClick={() => handleAdd()}>
              Add Email Event
            </Button>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin size="large" style={{ display: 'block', marginTop: 20 }} />
      ) : (
        <Table columns={columns} dataSource={eventList} rowKey="id" />
      )}
      <Modal
        title={selectedEvent ? 'Edit Event' : 'Add Event'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}
        destroyOnClose
      >
        <AddEditEvent eventId={selectedEvent} onSuccess={handleModalClose} />
      </Modal>

    </div>
  )
}

export default EmailEventList